export const ApiConstants = {
  // ORDER TYPES
  TYPE_PICKUP: 'pickup',
  TYPE_DELIVERY: 'delivery',

  // PAYMENT TYPES
  PAY_BY_CASH: 'pay_by_cash',
  PAY_BY_LINK: 'pay_by_link',

  // SOURCES
  SOURCE_PRIME: 'prime',
  SOURCE_ORDER_LINE_AGENT: 'order-line-agent',

  // MODULES
  MODULE_ORDER_LINE: 'order_line',
} as const;
